import React from "react";

export function AlertModalInput({ label, value, onChange, valid, type, onFocus, placeholder, required = false }) {
    const fieldId = `oct-alert-modal-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

    return (
        <div className="form-group oct_alert-v2-field">
            <div className="oct_alert-v2-form-group">
                <label htmlFor={fieldId} className="oct_alert-v2-label">
                    {label}
                    {required && <span className="modal-v2-required-mark">*</span>}
                </label>
                <input type={type || 'text'}
                    id={fieldId}
                    className={`form-control oct_alert-v2-input ${valid ? '' : 'border-danger'}`}
                    value={value}
                    placeholder={placeholder}
                    onChange={event => onChange(event.target.value)}
                    onFocus={onFocus} />
            </div>
        </div>
    )
}
